import { createReducer } from '../utils';

const SHOW_DIALOG = 'SHOW_DIALOG';
const HIDE_DIALOG = 'HIDE_DIALOG';

export function doShowDialog(dialogType, dialogProps) {
	return {
		type: SHOW_DIALOG,
		dialogType,
		dialogProps
	};
}

export function doHideDialog() {
	return {
		type: HIDE_DIALOG
	};
}

const initialState = {
	dialogType: null,
	dialogProps: {}
};

const dialog = createReducer(initialState, {
	[SHOW_DIALOG]: (state, action) => {
		const { dialogType, dialogProps } = action;
		return {
			dialogType,
			dialogProps
		};
	},
	[HIDE_DIALOG]: (state, action) => initialState
});

export function getDialog(state) {
	return state.app.dialog;
}

export default dialog;



// WEBPACK FOOTER //
// ./src/js/reducers/app/dialog.js